module.exports = __webpack_public_path__ + "img/组 104.b4cf8f72.png";